

  import {AuditUserLogType} from "@/api/appService";
  import AuditTabPane from "@/views/audits/components/AuditTabPane.vue";
  import api from '@/api';
  import {Vue, Component} from "vue-property-decorator";

  @Component({name:'AuditTabOfPayrollRequisition',components:{
      AuditTabPane
    }})
  export default class AuditTabOfPayrollRequisition extends Vue{

    getHostType(){
      return AuditUserLogType.PayrollRequisition;
    }

    audit(){
      return api.payrollRequisition.audit;
    }

    fetchData(){
      return api.payrollRequisition.getMyAll;
    }

    handleCountChange(value:number){
      this.$emit('count-changed',value);
    }

  }
